import React from 'react';
import type { Campaign } from '../../services/api';
import { useT } from '../../i18n/LanguageContext';

const StatusBadge: React.FC<{ status: Campaign['status'] }> = ({ status }) => {
  const t = useT();
  const labels: Record<Campaign['status'], string> = {
    draft: t('Nacrt', 'Draft'),
    scheduled: t('Zakazana', 'Scheduled'),
    sending: t('U toku', 'Sending'),
    completed: t('Završena', 'Completed'),
    failed: t('Neuspela', 'Failed'),
  };
  return (
    <span className={`badge badge-${status}`}>
      <span className="dot" />
      {labels[status] ?? status}
    </span>
  );
};

export default StatusBadge;
